import { render, staticRenderFns } from "./ArchivedCauselistList.vue?vue&type=template&id=5f3153c2&scoped=true"
import script from "./ArchivedCauselistList.vue?vue&type=script&lang=js"
export * from "./ArchivedCauselistList.vue?vue&type=script&lang=js"
import style0 from "./ArchivedCauselistList.vue?vue&type=style&index=0&id=5f3153c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3153c2",
  null
  
)

export default component.exports